export const SMART_RD_KEY = 'smartRedirect';

export const getSmartRedirect = () => {
  const smartRedirect = sessionStorage.getItem(SMART_RD_KEY);
  if (smartRedirect) {
    sessionStorage.removeItem(SMART_RD_KEY);
    return smartRedirect;
  }
  return false;
};

export const isSmartRedirect = () => {
  return !!sessionStorage.getItem(SMART_RD_KEY);
};
